export default {
  // États de chargement et d'erreur
  loading: 'Chargement de l\'emplacement...',
  fetchError: 'Échec du chargement des détails de l\'emplacement',
  errorTitle: 'Erreur',
  notFound: 'Emplacement introuvable',

  // Détails de l'emplacement
  address: 'Adresse',
  building: 'Bâtiment',
  floor: 'Étage',
  room: 'Salle',
  createdAt: 'Créé',
  updatedAt: 'Modifié',

  // Section des ressources
  resourcesInLocation: 'Ressources dans cet emplacement',
  resourcesDescription: 'Parcourir toutes les ressources stockées à {{locationName}}',

  // Onglets des transactions
  transactions: {
    resources: 'Ressources',
    borrowings: 'Emprunts',
    consumptions: 'Consommations',
    refills: 'Réapprovisionnements',
    resourcesInLocation: 'Ressources dans cet emplacement',
    borrowingsFromLocation: 'Emprunts de cet emplacement',
    consumptionsFromLocation: 'Consommations de cet emplacement',
    refillsToLocation: 'Réapprovisionnements vers cet emplacement'
  }
};
